module.exports = __webpack_public_path__ + "img/fuwuhao1@2x.cb173147.png";